// extracted by mini-css-extract-plugin
export default {"label":"Label_label__lHVx6","required_before":"Label_required_before__GUHrq","required_after":"Label_required_after__gEeFP"};